import type { ComponentPropsWithoutRef, ReactNode } from "react";
import { Loader } from "@circle-react-uikit/Loader";
import { Modal } from "@circle-react-uikit/ModalV2";
import { Typography } from "@circle-react-uikit/Typography";

interface MomentumModalProps
  extends Omit<
    ComponentPropsWithoutRef<typeof Modal>,
    "shouldShowCloseButton"
  > {
  children?: ReactNode;
  description: string;
  isLoading?: boolean;
  size?: ComponentPropsWithoutRef<typeof Modal.Content>["size"];
  title: string;
}

export function MomentumModal({
  title,
  description,
  onClose,
  children,
  isLoading,
  size = "md",
  ...rest
}: MomentumModalProps) {
  return (
    <Modal onClose={onClose} {...rest}>
      <Modal.Overlay />
      <Modal.Content className="!rounded-2xl" size={size}>
        {isLoading && (
          <div className="absolute inset-0 flex items-center justify-center">
            <Loader aria-live="polite" aria-busy="true" />
          </div>
        )}
        <Modal.Header className="!justify-end">
          <Modal.HeaderActions>
            <Modal.CloseButton
              iconClassName="!text-default"
              onClick={onClose}
            />
          </Modal.HeaderActions>
        </Modal.Header>
        <Modal.Body className="pb-12">
          <div className="flex flex-col gap-y-10">
            <div className="flex flex-col gap-y-3 text-pretty text-center">
              <Modal.Title>{title}</Modal.Title>
              <Typography.BodyMd color="text-default">
                {description}
              </Typography.BodyMd>
            </div>
            <div className="flex flex-col items-center">{children}</div>
          </div>
        </Modal.Body>
      </Modal.Content>
    </Modal>
  );
}
